
const baseUrlSR = 'https://www.smartrecruiters.com/identity/oauth';
const redirect_url = `${process.env.REACT_APP_PUBLISH_URL}/employer/jobs`
export const scope = 'job_applications_read%20jobs_read%20jobs_manage%20analytics_read%20company_read%20reporting_read%20reviews_read%20reviews_write%20approvals_read%20approvals_create';
const response_code = 'code'; // code=DCRA1-5781dae47757870172e94efd74055b3aaba8ba3f
export const linkAuthFromSR = `${baseUrlSR}/allow?client_id=${process.env.REACT_APP_ATS_SMARTRECRUITERS_CLIENT_ID}&redirect_uri=${encodeURIComponent(redirect_url)}&scope=${scope}`;

export const toSRPostLink = (jobId: string, jobAdsId: string) :string => `https://www.smartrecruiters.com/app/jobs/details/${jobId}/jobad/${jobAdsId}`
